import puTianShiTuShuGuanMapToolTipPlugin from "./plugins/puTianShiTuShuGuanMapToolTipPlugin"
import daHeKouShiMapToolTipPlugin from "./plugins/daHeKouShiMapToolTipPlugin"
import dongXiHuQuMapTooltipPlugin from "./plugins/dongXiHuQuMapTooltipPlugin"
import yangShanXianWenHuaGuanPlugin from "./plugins/yangShanXianWenHuaGuanPlugin"
import xidianMapLinePlugin from "./plugins/xidianMapLinePlugin"
import anKangBigDataPlugin from "./plugins/anKangBigDataPlugin"
export default {
  mixins: [
    puTianShiTuShuGuanMapToolTipPlugin,
    daHeKouShiMapToolTipPlugin,
    dongXiHuQuMapTooltipPlugin,
    yangShanXianWenHuaGuanPlugin,
    xidianMapLinePlugin,
    anKangBigDataPlugin
  ]
}
